<template>
    <div>
        <cp-comment-input v-if="displayCommentInput || (isTextEditorDisplayed[`${type}-${id}`] ?? false)" :send="sendComment" style="margin-bottom: 10px" sendToRep></cp-comment-input>
        <div v-if="moreComments && !loading" class="content-2 pointer" @click="loadComments(commentsPage + 1)">Show All Comments</div>
        <div v-if="loading" class="heading-4 text-center"><vue-simple-spinner v-margin="1" />Loading...</div>
        <cp-comments-item v-else-if="(areCommentsDisplayed[`${type}-${id}`] ?? true)" v-for="comment in comments" :key="comment.id" :data="comment" :type="type" :loadComments="loadComments" :setCount="setCount" />
        <cp-dialog-auth-form v-if="showAuthModal" :handleCloseButton="handleCloseButton" showSignUp :callback-action="handleComment" />
        <CpVerifyEmailDialog v-if="showVerifyEmailModal" :handleDialog="handleVerifyEmailModal" />
        <CpLobbyFlowDialog v-if="showLobbyDialog" :showDialog="showLobbyDialog" type="none" @close="handleLobbyDialogClose" customSubject="Concern over government spending" :commentToRep="commentToRep" />
    </div>
</template>

<script>
import * as API from '../api/comments';
import { mapActions, mapState } from 'pinia';

import { useCommentStore } from '../../../store/useCommentStore.js';
import { useUserStore } from '../../../store/useUserStore.js';

export default {
    data() {
        return {
            comments: [],
            commentsPage: 0,
            loading: false,
            moreComments: false,
            showAuthModal: false,
            commentData: { comment: '', gif: '', image: '', video: ''},
            sendToRepresentatives: false,
            showLobbyDialog: false,
            commentToRep: null,
            showVerifyEmailModal: false,
            onSucces: () => {},
            onError: () => {},
        };
    },
    computed: {
        authUser() {
            return this.$root.authUser;
        },
        ...mapState(useCommentStore, ['areCommentsDisplayed', 'isTextEditorDisplayed']),
        ...mapState(useUserStore, ['isUserLogin', 'userProfileData']),
    },
    mounted() {
        this.loadComments(0);
    },
    methods: {
        async sendComment({opinion: comment, gif, image, video, sendToRepresentatives}) {
            this.commentData = { comment, gif: gif, image: image, video: video };
            this.sendToRepresentatives = sendToRepresentatives;
            if (this.isUserLogin && !this.userProfileData?.email_verified) {
                await this.getUserProfile();
            }

            if (!this.authUser) {
                this.showAuthModal = true;
            } else if (!this.userProfileData?.email_verified) {
                this.showVerifyEmailModal = true;
            } else {
                this.loading = true;
                this.handleComment();
                this.loading = false;
            }
        },
        async handleComment() {
            await API.comment(this.id, this.type, { ...this.commentData, reply_id: null })
                .then(() => {
                    this.comments = [];
                    this.loadComments(0);
                    this.setCount('add');
                    this.onSucces();
                    if (this.sendToRepresentatives) {
                        this.showLobbyDialog = true;
                        this.commentToRep = this.stripHtml(this.commentData.comment);
                    }
                })
                .catch((error) => {
                    this.onError(error);
                });
        },
        handleLobbyDialogClose() {
            this.showLobbyDialog = false;
            this.commentToRep = null;
        },
        handleVerifyEmailModal() {
            this.showVerifyEmailModal = !this.showVerifyEmailModal;
        },
        handleCloseButton() {
            this.showAuthModal = false;
        },
        async loadComments(page) {
            this.loading = true;
            if (page == 0) {
                this.comments = [];
            }
            else {
                this.handleDisplayComments({type: this.type, id: this.id})
            }
            await API.comments(this.id, this.type, { page: page })
                .then(async (response) => {
                    this.comments = await this.sort(response.comments);
                    if (page == 0 && response.comments.length) {
                        this.moreComments = response.comments.length > 4;
                    } else {
                        this.moreComments = false;
                    }
                    this.commentsPage = page;
                })
                .catch((error) => {
                    console.warn(error);
                });

            this.loading = false;
        },
        sort(comments) {
            return comments
                .sort((a, b) => {
                    const dateA = new Date(a.created_at).getTime();
                    const dateB = new Date(b.created_at).getTime();
                    return dateA - dateB;
                })
                .concat(this.comments);
        },
        ...mapActions(useCommentStore, ['handleDisplayComments']),
        ...mapActions(useUserStore, ['getUserProfile']),
    },

    props: {
        id: [String, Number],
        type: String,
        setCount: Function,
        displayCommentInput: {
            type: Boolean,
            default: false,
        },
    },

    directives: {
        margin: require('../directives/margins').margin,
        marginBottom: require('../directives/margins').marginBottom,
        marginTop: require('../directives/margins').marginTop,
    },

    components: {
        CpButton: require('../button'),
        CpImage: require('../image'),
        CpCommentsItem: require('./comments-item').default,
        CpCommentInput: require('./comment-input').default,
        VueSimpleSpinner: require('../vue-simple-spinner').default,
        InfiniteLoading: require('vue-infinite-loading').default,
        CpDialogAuthForm: require('../auth-form/dialog-auth-form').default,
        CpLobbyFlowDialog: require('../dialogs/LobbyFlowDialog').default,
        stripHtml: require('../mixins/utils').default,
        CpVerifyEmailDialog: require('../dialogs/VerifyEmail').default,
    },
};
</script>

<style scoped>
.pointer {
    cursor: pointer;
}
.text-center {
    text-align: center;
}
.modal-content {
    max-width: 460px;
    padding: 40px 80px 30px;
    text-align: center;
}
.mt-10 {
    margin-top: 10px;
}
@media (max-width: 768px) {
    .modal-content {
        padding: 20px 40px;
    }
}
/* transition styles */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s ease-in-out;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
